import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import IndexHero from '../partials/Home/Hero';
import Products from '../partials/Home/Products';

const IndexPage = () => (
  <Layout>
    <IndexHero />
    <Products />
  </Layout>
);

export default IndexPage;

export const Head = () => (
  <SEO
    title="Digital Inspiration - Automate your Business with Google Addons for Gmail and Google Workspace"
    description="Google Workspace add-ons help you automate business workflows and improve productivity. Available for Gmail, Google Drive, Docs, Sheets, Google Forms and GSuite."
  />
);
